import { createContext } from 'react'

export const CursorModeContext = createContext({
  cursorMode: 'DEFAULT',
  setCursorMode: (mode) => {},
})
